module.exports = __webpack_public_path__ + "img/waiterForbidden.ddb72235.png";